import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-stone-50" data-id="element-92" data-mp="4uqcgsut9wrq">
      <div className="mx-auto flex max-w-2xl flex-col items-center px-5 py-16 text-center lg:py-20" data-id="element-93" data-mp="4xcmr0936qdn">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-white shadow-lg shadow-stone-900/10" data-id="element-94" data-mp="9wphe76791qs">
          <ShieldCheckIcon className="h-6 w-6 text-brand" aria-hidden="true" data-id="element-95" data-mp="jssgf45r8k9i" />
        </span>

        <h2 id="garantia" className="mt-7 font-serif text-xl font-black uppercase leading-snug tracking-[0.01em] text-stone-900 sm:text-2xl" data-id="element-96" data-mp="ntvxtv3gaocu">
          Garantía “Satisfecho o Reembolsado”
        </h2>

        <div className="mt-5 max-w-xl space-y-4 text-[15px] leading-relaxed text-stone-600 sm:text-base" data-id="element-97" data-mp="xjnwb0eo81ml">
          <p data-id="element-98" data-mp="12jk0azndbt25">Queremos que puedas revisar el material y decidir si es lo que necesitás para estudiar.</p>
          <p data-id="element-99" data-mp="17hlizjgvtqd3">
            Tenés 7 días desde la compra para solicitar el reembolso si el MegaPack no es lo que esperabas. Escribinos al correo de atención indicado en tu comprobante de compra.
          </p>
        </div>

        <a href="#politica-reembolso" className="mt-6 text-sm font-bold text-brand underline decoration-brand/50 underline-offset-4 transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:text-brand-dark" data-id="element-100" data-mp="20rsuj2sdi9be">
          Ver política completa de reembolso
        </a>
      </div>
    </section>;
}